// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getCustomerOptionsMonthlyService = async () => {
  try {
    return await http.get<any>(`/v1/services-ia-usage-monthlys/form`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getCustomerOptionsMonthlyService ', error);
  }
};

export const getServicesIaUsageMonthlysAnalyticsService = async (query?: any) => {
  try {
    // Filter out undefined, null, or empty string values
    const validParams = Object.entries(query || {}).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    );
    const queryString = new URLSearchParams(validParams as string[][]).toString();

    return await http.get<any>(
      `/v1/services-ia-usage-monthlys/analytics${queryString ? `?${queryString}` : ''}`
    );
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.log('getServicesIaUsageMonthlysAnalyticsService ', error);
  }
};
